import { render, staticRenderFns } from "./WarehouseHistory.vue?vue&type=template&id=c98cc584&"
import script from "./WarehouseHistory.vue?vue&type=script&lang=js&"
export * from "./WarehouseHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports